import { render } from "./Bruder.vue?vue&type=template&id=0b42e4ed"
import script from "./Bruder.vue?vue&type=script&lang=js"
export * from "./Bruder.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__